import React from 'react'
import { Link } from 'react-router-dom'
import { Action, IOWidget, mk_widget, mkWidget, nothing, Widget, lifecycle, Fun } from 'widgets-for-react'
import { link, linkWrapper } from '../../cms/blocks/utils.gen'
import {
  HeaderAccountMenu,
  HeaderAccountMenuBlockItem,
  HeaderMenuBlocks,
  HeaderMenuItem,
  HeaderMenuItems,
  HeaderMenuLink,
  HeaderMenuLinkList,
  HeaderMenus,
  HeaderState,
  OptionsState
} from '../../public_site.main.mod'
import { closeAccountMenu, closeMenuItems as closeAllMenuItems } from '../application.mod'
import { DataLayer } from '../utils/datalayer'

const headerMenu: IOWidget<HeaderState, Action<HeaderState>> = props =>
  props.menu.kind === 'loaded'
    ? menu(props.menu.value).map(a => s1 => {
        if (s1.menu.kind !== 'loaded') {
          return s1
        }

        return {
          ...s1,
          menu: {
            ...s1.menu,
            value: a(s1.menu.value)
          }
        }
      })
    : nothing()

const menuLink: IOWidget<HeaderMenuLink, Action<HeaderMenuLink>> = item =>
  mk_widget({
    run: setState => link(item, { classname: 'nav-item__link' }, item.title)
  })

const menuBlocks: IOWidget<HeaderMenuBlocks, Action<HeaderMenuBlocks>> = item =>
  mk_widget({
    run: setState => (
      <>
        <button
          onClick={() => setState(s1 => ({ ...s1, open: !s1.open }))}
          className={`nav-item__button nav-item__button--${item.open ? 'open' : 'closed'}`}
        >
          {item.title}
          <svg className="nav-item__icon nav-item__icon--right" width="6" height="8">
            <use xlinkHref="#icon--caret" />
          </svg>
        </button>

        <div className={`submenu submenu--grid submenu--${item.open ? 'open' : 'closed'}`}>
          <div className="submenu-column__titles">
            <p className="title--m submenu-column__title">{item.title}</p>
          </div>
          <ul className={`flex flex--${item.blocks.count()} grid`}>
            {item.blocks.map((block, index) => (
              <li key={`menublock-${index}`} className="flex-item grid-item">
                {link(
                  block.link,
                  { classname: 'grid-item__link' },
                  <div className="grid-item__content">
                    {block.subtitle && <p className="title--xxs grid-item__subtitle">{block.subtitle}</p>}
                    <p className="title--s grid-item__title">{block.title}</p>
                    <p className="">{block.text}</p>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </>
    )
  })

const menuLinkList: IOWidget<HeaderMenuLinkList, Action<HeaderMenuLinkList>> = item =>
  mk_widget({
    run: setState => (
      <>
        <button
          onClick={() => setState(s1 => ({ ...s1, open: !s1.open }))}
          className={`nav-item__button nav-item__button--${item.open ? 'open' : 'closed'}`}
        >
          {item.title}
          <svg className="nav-item__icon nav-item__icon--right" width="6" height="8">
            <use xlinkHref="#icon--caret" />
          </svg>
        </button>

        <div className={`submenu submenu--link-list submenu--${item.open ? 'open' : 'closed'}`}>
          {item.list.map((list, index) => (
            <div key={`submenu-${index}`} className={`submenu-column submenu-column--${index + 1}`}>
              <div className="submenu-column__titles">
                <p className="title--m submenu-column__title">{index === 0 ? list.title : 'informatie voor'}</p>
                {list.text && <p>{list.text}</p>}
              </div>

              <ul className="submenu-column__list">
                {list.links.map((l, key) => (
                  <li key={`submenu-${index}-item-${key}`}>{link(l, { classname: 'submenu-column__link link-button' }, l.title)}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </>
    )
  })

const menu: IOWidget<HeaderMenus, Action<HeaderMenus>> = items =>
  mkWidget<Action<HeaderMenus>>({
    run: setState => (
      <ul className="nav nav--main">
        {items.headerMenuItems
          .map((item, index) => {
            let itemWidget = ((item.kind === 'blocks'
              ? menuBlocks(item)
              : item.kind === 'linkList'
              ? menuLinkList(item)
              : menuLink(item)) as Widget<Action<HeaderMenuItem>>).map<Action<HeaderMenus>>(a => s1 => ({
              ...s1,
              headerMenuItems: closeAllMenuItems(s1.headerMenuItems).set(index, a(item)),
              account: closeAccountMenu(s1.account)
            }))

            return (
              <li key={`main-nav-item-${index}`} className="nav-item">
                {itemWidget.run(setState)}
              </li>
            )
          })
          .valueSeq()}
        {accountMenu(items.account)
          .map<Action<HeaderMenus>>(a => s1 => ({
            ...s1,
            account: a(s1.account),
            headerMenuItems: closeAllMenuItems(s1.headerMenuItems)
          }))
          .run(setState)}
        <li className="nav-item">
          <a
            href="/shop"
            className="nav-item__link nav-item__link--last nav-item__link--shop"
            onClick={() => DataLayer.clickToShop()}
          >
            <svg className="nav-item__icon nav-item__icon--left" width="10" height="9">
              <use xlinkHref="#icon--cart" />
            </svg>
            <span>naar de shop</span>
          </a>
        </li>
      </ul>
    )
  })

export const accountMenu = (s0: HeaderAccountMenu, action: () => void = () => {}): Widget<Action<HeaderAccountMenu>> => mkWidget({
  run: setState => s0.items.length == 0 ? (
    <li className="nav-item nav-item--right">
      {link(
        linkWrapper({ title: "BSL account", url: "/mijn-account" }),
        { classname: 'nav-item__link nav-item__link--account' },
        <>
          <svg className="nav-item__icon nav-item__icon--left" width="10" height="10">
            <use xlinkHref="#icon--person" />
          </svg>
          <span>mijn account</span>
        </>,
        () => DataLayer.clickToMyAccount()
      )}
    </li>
  ) : (
    <li className="nav-item nav-item--right dropdown">
      <button
        className="nav-item__link nav-item__link--account"
        onClick={(e) => {
          action()
          DataLayer.clickToMyAccount()
          setState(s1 => ({...s1, open: !s1.open }))
        }}
      >
        <svg className="nav-item__icon nav-item__icon--left" width="10" height="10">
          <use xlinkHref="#icon--person" />
        </svg>
        <span>mijn account</span>
      </button>
      <ul className={`dropdown__list${s0.open ? '' : ' dropdown__list--hidden'}`}>
        {s0.items.map(({link: item}) => (
          <li className="dropdown__item">
            {link(
              item,
              { classname: 'dropdown__link' },
              <>
                <svg className="dropdown__icon" width="10" height="10">
                  <use xlinkHref="#icon--person" />
                </svg>
                <span className="dropdown__text">{item.title}</span>
              </>
            )}
          </li>
        ))}
      </ul>
    </li>
  )
})

export const headerDisplay: (props: HeaderState) => Widget<Action<HeaderState>> = props =>
  mk_widget({
    run: setState => (
      <header className={`header header--main`}>
        <div className="header__inner">
          <div className={`header__logo`}>
            <Link to="/">
              <img src="/frontend/images/logo.svg" alt="BSL Logo" />
            </Link>
          </div>
          <nav className={`header__menu ${props.open ? 'header__menu--open' : 'header__menu--closed'}`}>
            {headerMenu(props).run(setState)}
          </nav>
          <button
            aria-hidden="true"
            className={`header__menu-toggle ${props.open ? 'header__menu-toggle-open' : 'header__menu-toggle-closed'}`}
            onClick={() => setState(s1 => ({ ...s1, open: !s1.open }))}
          >
            <span />
          </button>
        </div>
      </header>
    )
  })

const handleClickOutsideMenu: Fun<Fun<Action<HeaderState>, void>, Fun<MouseEvent, void>> = setState => e => {
  if (!document.querySelector('.header.header--main').contains(e.target as Node)) {
    setState(s1 => ({
      ...s1,
      menu: s1.menu.kind === 'loaded' ? { ...s1.menu, value: {
        headerMenuItems: closeAllMenuItems(s1.menu.value.headerMenuItems),
        account: closeAccountMenu(s1.menu.value.account)
      } } : s1.menu,
      open: false
    }))
  }
}

export const header = lifecycle<HeaderState>({
  componentDidMount: setState => window.addEventListener('click', handleClickOutsideMenu(setState)),
  componentWillUnmount: setState => window.removeEventListener('click', handleClickOutsideMenu(setState))
})(headerDisplay)
